<ap-paragraph-skeleton [rows]="2"></ap-paragraph-skeleton>
<ap-input-skeleton></ap-input-skeleton>
<ap-paragraph-skeleton [rows]="2"></ap-paragraph-skeleton>
<ap-button-skeleton class="ap-sign__phone-number-skeleton_button"> </ap-button-skeleton>
